import FormInputControl from "lib/formInputs/formInputGroups/FormInputControl";
import FormInputError from "lib/formInputs/formInputGroups/FormInputError";
import FormInputLabel from "lib/formInputs/formInputGroups/FormInputLabel";
import PropTypes from "prop-types";
import React from "react";
import InputGroup from "react-bootstrap/InputGroup";

function FormInputGroup(props) {
  const {
    formPlaceholder,
    formAriaLabel,
    describedBy,
    inputType,
    className,
    name,
    formLabel,
    igtId,
    formik,
    inputIcon,
    labelClassName,
    checked,
    value,
    required,
  } = props;

  return (
    <>
      <FormInputLabel
        formLabel={formLabel}
        className={labelClassName}
        required={required}
      />
      <InputGroup className="mb-0">
        <InputGroup.Text
          id={igtId}
          className="bg-transparent pe-0  border-end-0"
        >
          <span className={` fs-20 ${inputIcon}`}></span>
        </InputGroup.Text>
        <FormInputControl
          formPlaceholder={formPlaceholder}
          formAriaLabel={formAriaLabel}
          describedBy={describedBy}
          inputType={inputType}
          className={className}
          name={name}
          formik={formik}
          value={value}
          checked={checked}
          showError={false}
        />
      </InputGroup>
      <FormInputError formik={formik} name={name} />
    </>
  );
}

export const defaultProps = {
  variant: "",
  type: "",
  className: "",
  placeholder: "",
  label: "",
  ariaLabel: "",
  ariaDescribedby: "",
  text: "",
};

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  disabled: PropTypes.bool,
  formik: PropTypes.object,
};

FormInputGroup.defaultProps = defaultProps;

FormInputGroup.propTypes = propTypes;
export default FormInputGroup;
